import Layout from '../Component/layout/main-layout';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import layoutBgImg from '../Images/layout/services.jpg';
import ServicesLayout from '../Component/layout/services-layout';
import GlobalLayout from '../Component/layout/global-layout';
import { servicesData } from '../data/servicesData';

const OnlineService = () => {
    const { t } = useTranslation()
    const gridClasses = {
        1: "xl:col-span-1 xl:row-span-1",
        2: "xl:col-span-1 xl:row-span-1",
        3: "xl:col-span-1 xl:row-span-2",
        4: "xl:col-span-1 xl:row-span-1",
        5: "xl:col-span-1 xl:row-span-1",
        6: "xl:col-span-2 xl:row-span-1",
        7: "xl:col-span-1 xl:row-span-1",
    };
    return (
        <GlobalLayout
            title={`${t('online_services')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Onlaýn hyzmatlar, Hyzmatlar, Онлайн услуги, Kazyyet hyzmatlary"
        >
            <div className='mb-20'>
                <Layout
                    title={t('online_services')}
                    layoutBgImg={layoutBgImg}
                />
                <ServicesLayout />
                <div className='bg-white dark:bg-dark-box mx-4 xxl:mx-12 
                                xxxl:mx-32 xxxxl:mx-64 xxxxxl:mx-[400px]                             
                                xxxxxxl:mx-[650px] xxxxxxxl:mx-[1600px]
                                xxxxxxxxl:mx-[2400px]'>
                    <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 
                                      auto-rows-[220px] gap-6 p-4 xl:p-8'>
                        {servicesData?.map((d) => (
                            <Link
                                to={d.link}
                                key={d.id}
                                className={`${gridClasses[d.id]}`}
                            >
                                <div
                                    className='relative text-center card h-full rounded-xl 
                                                   py-20 px-2 shadow-sm border border-text
                                                   transition-transform duration-500 ease-out
                                                   hover:scale-[1.04] hover:shadow-xl overflow-hidden'
                                    style={{
                                        backgroundImage: `url(${d.backgroundImage})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                    }}
                                >
                                    <div className="absolute inset-0 bg-black opacity-40 rounded-xl"></div>
                                    <div className='relative flex flex-col text-white
                                                        justify-center items-center h-full'>
                                        <span>{d.icon}</span>
                                        <p className='mt-4 font-bold text-xl'>
                                            {t(d.name)}
                                        </p>
                                    </div>

                                </div>

                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </GlobalLayout>
    );
};

export default OnlineService;